import { type IStatusProps, Status } from 'shared/ui/Status'

type IStatusConfig = Pick<IStatusProps, 'icon' | 'title' | 'intent'>

const ACTIVE_STATUS_CONFIG: IStatusConfig = {
  icon: 'check2',
  title: 'Active',
  intent: 'positive',
}

const DISABLED_STATUS_CONFIG: IStatusConfig = {
  icon: 'minusCircle',
  title: 'Disabled',
  intent: 'neutral',
}

const INVALID_STATUS_CONFIG: IStatusConfig = {
  title: 'Invalid',
  icon: 'closeCircle',
  intent: 'negative',
}

const DRAFT_STATUS_CONFIG: IStatusConfig = {
  title: 'Draft',
  icon: 'draft',
  intent: 'neutral',
}

export interface IWorkflowStatusBadge {
  active: boolean
  isInvalid: boolean
  draft?: boolean
}

export const WorkflowStatusBadge = ({ active, isInvalid, draft }: IWorkflowStatusBadge) => (
  <Status
    {...(isInvalid
      ? INVALID_STATUS_CONFIG
      : active
      ? ACTIVE_STATUS_CONFIG
      : draft
      ? DRAFT_STATUS_CONFIG
      : DISABLED_STATUS_CONFIG)}
    emphasis={'high'}
  />
)
